import { useContext } from "react";
import type {
	BlockGridItemRendererMapping,
	BlockGridItemRendererProps,
} from "#/_packages/umbrella/integrations/umbraco/utils/renderer-mappings.tsx";
import FaqList from "#/app/components/faq-list";
import { SearchPageTagFilterContext } from "#/app/components/search/search-page-settings";
import { SearchResults } from "#/app/components/search/search-results.tsx";
import ElementTypes from "#/app/features/rendering/utils/element-types.ts";

const gsaBlockGridItemTypes = [
	ElementTypes.FaqListBlock,
	ElementTypes.SearchResultsBlock,
];

function GsaBlockGridItemRenderer({
	model,
	className,
	options,
}: BlockGridItemRendererProps) {
	const showContentTagFilter = useContext(SearchPageTagFilterContext);
	switch (model.content.contentType) {
		case ElementTypes.SearchResultsBlock:
			return (
				<SearchResults
					className={className}
					isPreview={options?.isPreview}
					showContentTagFilter={showContentTagFilter}
					contained={false}
				/>
			);
		case ElementTypes.FaqListBlock:
			return <FaqList content={model.content} />;
	}
}

export const gsaBlockGridItemRenderers: BlockGridItemRendererMapping =
	Object.fromEntries(
		gsaBlockGridItemTypes.map((contentType) => [
			contentType,
			GsaBlockGridItemRenderer,
		]),
	);
